/**
 * @description 客户授权免密登录
 * @author liushuai
 * @see http://api.umucdn.cn/project/377/interface/api/5183
 */

import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/microapi/base';

export const AuthAPI = {
    /**
     * 创建授权链接
     */
    USER_TEMPPRIVILEGE: {
        url: `${BasePath}/user/tempprivilege`,
        type: API_TYPE.POST,
    },

    /**
     * 创建授权链接
     */
    GET_TOKEN: {
        url: `${BasePath}/user/token`,
        type: API_TYPE.POST,
    },
};
